<template>
    <div
        class="el-form-card"
        v-loading="isLoading"
        :element-loading-text="$t('message.other.loading')"
        element-loading-background="rgba(0, 0, 0, 0.8)"
    >
        <div class="el-form-card__header">
            {{ formText }} {{ $t('form.title.user') }}
            <span
                v-if="this.user && this.user.ContainerId"
                style="font-size: 12px; color: #30c1af"
                >: {{ form.firstName }} {{ form.lastName }}
            </span>
            <!--            {{(this.user && this.user.ContainerId) ? this.user.ContainerDescription : selectedContainer.Description }}-->
        </div>
        <div class="el-form-card__body">
            <el-form
                ref="form"
                class="dark-form"
                :model="form"
                :rules="rules"
                size="mini"
                label-position="top"
                label-width="125px"
            >
                <!--                <el-row v-if="!(this.user && this.user.ContainerId) && selectedContainer.ContainerType === 'CCC'">-->
                <!--                    <div class="el-form-card__element-wrapper mt-3">-->
                <!--                        <el-form-item prop="container">-->
                <!--                            <treeselect-->
                <!--                                v-model="selectedContainerFromTreeSelect"-->
                <!--                                value-format="object"-->
                <!--                                class="supplier-tree-select"-->
                <!--                                :flat="true"-->
                <!--                                :clearable="false"-->
                <!--                                :placeholder="-->
                <!--                                        $t('form.label.selectSearchContainer')-->
                <!--                                    "-->
                <!--                                :options="selectedContainerTree"-->
                <!--                                :normalizer="normalizer"-->
                <!--                            />-->
                <!--                        </el-form-item>-->
                <!--                    </div>-->
                <!--                </el-row>-->
                <el-row>
                    <div class="el-form-card__element-wrapper">
                        <el-form-item prop="firstName">
                            <v-text-field
                                :label="$t('form.label.firstName')"
                                v-model="form.firstName"
                                required
                            ></v-text-field>
                        </el-form-item>
                    </div>
                </el-row>

                <el-row>
                    <div class="el-form-card__element-wrapper">
                        <el-form-item prop="lastName">
                            <v-text-field
                                :label="$t('form.label.lastName')"
                                v-model="form.lastName"
                                required
                            ></v-text-field>
                        </el-form-item>
                    </div>
                </el-row>

                <el-row>
                    <div class="el-form-card__element-wrapper">
                        <el-row>
                            <el-col :span="19">
                                <el-form-item prop="username">
                                    <v-text-field
                                        :label="$t('form.label.email')"
                                        v-model="form.username"
                                        :readonly="editing"
                                        required
                                    ></v-text-field>
                                </el-form-item>
                            </el-col>
                            <el-col :span="5" style="padding-top: 5px">
                                <span style="color: #989ea6">
                                    {{ $t('form.label.languageText') }}</span
                                >
                                <el-dropdown>
                                    <span style="color: #989ea6">
                                        {{ form.culture
                                        }}<i
                                            class="
                                                el-icon-caret-bottom
                                                el-icon--right
                                            "
                                        ></i>
                                    </span>
                                    <el-dropdown-menu slot="dropdown">
                                        <el-dropdown-item
                                            @click.native="
                                                form.culture = 'en-US'
                                            "
                                        >
                                            {{ $t('data.label.english') }}
                                            <span
                                                class="
                                                    el-flag-wrapper
                                                    flag-icon flag-icon-gb
                                                "
                                            ></span>
                                        </el-dropdown-item>
                                        <el-dropdown-item
                                            @click.native="
                                                form.culture = 'sv-SE'
                                            "
                                            divided
                                        >
                                            {{ $t('data.label.swedish') }}
                                            <span
                                                class="
                                                    el-flag-wrapper
                                                    flag-icon flag-icon-se
                                                "
                                            ></span>
                                        </el-dropdown-item>
                                    </el-dropdown-menu>
                                </el-dropdown>
                            </el-col>
                        </el-row>
                    </div>
                </el-row>

                <el-row>
                    <div class="el-form-card__element-wrapper">
                        <el-form-item prop="phone">
                            <v-text-field
                                :label="$t('form.label.phone')"
                                v-model="form.phone"
                                required
                            ></v-text-field>
                        </el-form-item>
                    </div>
                </el-row>

                <el-row>
                    <div
                        class="el-form-card__element-wrapper"
                        style="margin-top: 10px"
                    >
                        <el-form-item prop="company">
                            <v-text-field
                                :label="$t('form.label.company')"
                                v-model="form.company"
                                required
                            ></v-text-field>
                        </el-form-item>
                    </div>
                </el-row>

                <el-row>
                    <div class="el-form-card__element-wrapper" v-if="editing">
                        <el-form-item prop="newPassword">
                            <stc-password
                                labelText="Password"
                                v-model="form.newPassword"
                                fetch-url="Util/GeneratePassword"
                                :onLoadGenerate="true"
                            ></stc-password>
                        </el-form-item>
                    </div>
                    <div class="el-form-card__element-wrapper" v-else>
                        <el-form-item prop="password">
                            <stc-password
                                :labelText="$t('form.label.password')"
                                v-model="form.password"
                                fetch-url="Util/GeneratePassword"
                                :onLoadGenerate="true"
                            ></stc-password>
                        </el-form-item>
                    </div>
                </el-row>

                <el-row
                    v-if="permissions.includes('SUPER_USER')"
                    style="margin-top: 10px"
                >
                    <div
                        class="
                            el-form-card__element-wrapper
                            el-form-card__element-wrapper--expander
                        "
                    >
                        <el-form-item prop="allowGates">
                            <div class="el-checkbox-list">
                                <v-checkbox
                                    :label="$t('form.label.allowGates')"
                                    v-model="form.allowGates"
                                    color="success"
                                    hide-details
                                >
                                </v-checkbox>
                            </div>
                        </el-form-item>
                    </div>
                </el-row>

                <div class="form-expanded-content" v-if="form.allowGates">
                    <el-row>
                        <div class="el-form-card__element-wrapper">
                            <el-form-item prop="pinCode" class="form-element">
                                <stc-password
                                    :labelText="$t('form.label.pinCode')"
                                    readonly
                                    v-model="form.pinCode"
                                    fetch-url="Util/GeneratePin"
                                    :onLoadGenerate="true"
                                >
                                </stc-password>
                            </el-form-item>
                        </div>
                    </el-row>

                    <el-row>
                        <div class="el-form-card__element-wrapper">
                            <el-form-item
                                prop="destinationContainer"
                                class="form-element"
                            >
                                <v-select
                                    :items="currentSelectedContainers"
                                    item-text="Description"
                                    item-value="ContainerID"
                                    return-object
                                    v-model="form.destinationContainer"
                                    :label="$t('form.label.registerPassings')"
                                    dark
                                    required
                                >
                                </v-select>
                            </el-form-item>
                        </div>
                    </el-row>

                    <el-row>
                        <div class="el-form-card__element-wrapper">
                            <el-form-item prop="anpr">
                                <div
                                    class="
                                        el-checkbox-list
                                        el-checkbox-list--top-gap
                                    "
                                >
                                    <v-checkbox
                                        :label="$t('form.label.anpr')"
                                        :disabled="
                                            !permissions.includes('SUPER_USER')
                                        "
                                        v-model="form.anpr"
                                        color="success"
                                        hide-details
                                    >
                                    </v-checkbox>
                                </div>
                            </el-form-item>
                            <el-form-item prop="plateNo" v-if="form.anpr">
                                <v-text-field
                                    :label="$t('form.label.plateNo')"
                                    :readonly="
                                        !permissions.includes('SUPER_USER')
                                    "
                                    v-model="form.plateNo"
                                ></v-text-field>
                            </el-form-item>
                        </div>
                    </el-row>

                    <el-row>
                        <div
                            class="
                                el-form-card__element-wrapper
                                el-form-card__element-wrapper
                            "
                        >
                            <el-form-item prop="allowApp">
                                <div
                                    class="
                                        el-checkbox-list
                                        el-checkbox-list--top-gap
                                    "
                                >
                                    <v-checkbox
                                        :label="$t('form.label.allowApp')"
                                        v-model="form.allowApp"
                                        color="success"
                                        hide-details
                                    >
                                    </v-checkbox>
                                </div>
                            </el-form-item>

                            <el-form-item
                                v-if="form.allowApp"
                                style="padding-left: 10px"
                            >
                                <div
                                    class="
                                        el-checkbox-list
                                        el-checkbox-list--top-gap
                                    "
                                >
                                    <v-checkbox
                                        :label="
                                            $t(
                                                'form.label.allowAppRequirePinToOpenGate'
                                            )
                                        "
                                        v-model="form.PinValidationDisabled"
                                        color="success"
                                        hide-details
                                    >
                                    </v-checkbox>
                                </div>
                            </el-form-item>

                            <el-form-item
                                v-if="form.allowApp"
                                style="padding-left: 10px"
                            >
                                <div
                                    class="
                                        el-checkbox-list
                                        el-checkbox-list--top-gap
                                    "
                                >
                                    <v-checkbox
                                        :label="
                                            $t(
                                                'form.label.allowAppRequireCommentToOpenGate'
                                            )
                                        "
                                        v-model="form.OpenCommentDisabled"
                                        color="success"
                                        hide-details
                                    >
                                    </v-checkbox>
                                </div>
                            </el-form-item>

                            <el-form-item
                                v-if="form.allowApp"
                                style="padding-left: 10px"
                            >
                                <div
                                    class="
                                        el-checkbox-list
                                        el-checkbox-list--top-gap
                                    "
                                >
                                    <v-checkbox
                                        :label="
                                            $t(
                                                'form.label.allowAppRequireUserToOpenGate'
                                            )
                                        "
                                        v-model="
                                            form.LocationValidationDisabled
                                        "
                                        color="success"
                                        hide-details
                                    >
                                    </v-checkbox>
                                </div>
                            </el-form-item>
                        </div>
                    </el-row>

                    <el-row>
                        <div class="el-form-card__element-wrapper">
                            <el-form-item prop="schedule">
                                <v-select
                                    :items="schedules"
                                    :label="$t('form.label.selectSchedule')"
                                    v-model="form.schedule"
                                    item-value="Description"
                                    item-text="Description"
                                    return-object
                                    clearable
                                    multiple
                                    required
                                    chips
                                    dark
                                >
                                </v-select>
                            </el-form-item>
                        </div>
                    </el-row>

                    <el-row v-if="form.schedule.length && gates.length">
                        <div
                            class="
                                el-form-card__element-wrapper
                                input-group
                                pt-2
                            "
                        >
                            <label class="body-2">{{
                                $t('form.label.gates')
                            }}</label>
                        </div>
                    </el-row>

                    <el-row v-if="form.schedule.length && gates.length">
                        <div class="el-form-card__element-wrapper">
                            <stc-scheduled-gate-access
                                v-for="schedule in form.schedule"
                                :key="schedule.ScheduleTemplateID"
                                :scheduled-gates="
                                    form.scheduledGates[
                                        schedule.ScheduleTemplateID
                                    ]
                                "
                                :schedule="schedule"
                                :gates="gates"
                                @gates-scheduled="handleScheduledGates"
                            >
                            </stc-scheduled-gate-access>
                        </div>
                    </el-row>

                    <el-row v-if="selectedContainer.AutoPinEnabled">
                        <div
                            class="
                                el-form-card__element-wrapper
                                el-form-card__element-wrapper--expander
                            "
                        >
                            <el-form-item prop="isAdvance">
                                <div class="el-checkbox-list">
                                    <v-checkbox
                                        :label="
                                            $t('form.label.advancedSettings')
                                        "
                                        v-model="form.isAdvance"
                                        color="success"
                                        hide-details
                                    >
                                    </v-checkbox>
                                </div>
                            </el-form-item>
                        </div>
                    </el-row>

                    <div
                        class="el-form-card__element-wrapper"
                        v-if="form.isAdvance"
                    >
                        <el-form-item prop="autoPinChangeInterval">
                            <v-text-field
                                :label="$t('form.label.autoPinChangeInterval')"
                                v-model="form.autoPinChangeInterval"
                            ></v-text-field>
                        </el-form-item>
                        <el-form-item prop="autoPinNotificationRecipient">
                            <v-text-field
                                :label="$t('form.label.autoPinNotification')"
                                v-model="form.autoPinNotificationRecipient"
                            ></v-text-field>
                        </el-form-item>
                    </div>
                </div>

                <el-row>
                    <el-form-item>
                        <div class="el-form-card__element-wrapper date-wrapper">
                            <el-col :span="15" class="el-checkbox-list">
                                <v-checkbox
                                    :label="$t('form.label.expiryDate')"
                                    v-model="form.isExpiryDateEnabled"
                                    color="success"
                                    hide-details
                                >
                                </v-checkbox>
                                <el-date-picker
                                    :disabled="!form.isExpiryDateEnabled"
                                    style="width: 70%"
                                    v-model="form.expiryDate"
                                    size="mini"
                                    type="date"
                                    prefix-icon=""
                                    :clearable="false"
                                    :placeholder="$t('form.label.expiryDate')"
                                    :picker-options="pickerOptions"
                                >
                                </el-date-picker>
                            </el-col>
                            <el-col :span="9" class="el-checkbox-list">
                                <v-checkbox
                                    :label="$t('form.label.expiryTime')"
                                    v-model="form.isExpiryTimeEnabled"
                                    color="success"
                                    hide-details
                                >
                                </v-checkbox>
                                <el-time-select
                                    :disabled="!form.isExpiryTimeEnabled"
                                    style="width: 100%"
                                    placeholder="00:00"
                                    v-model="form.expiryTime"
                                    :clearable="false"
                                    size="mini"
                                    :picker-options="{
                                        format: 'HH:mm:ss',
                                        start: '00:00',
                                        step: timeStepper,
                                        end: '23:45',
                                    }"
                                >
                                </el-time-select>
                            </el-col>
                        </div>
                    </el-form-item>
                </el-row>

                <el-row>
                    <div class="el-form-card__element-wrapper">
                        <el-form-item prop="comment">
                            <v-text-field
                                :label="$t('form.label.additionalInformation')"
                                v-model="form.comment"
                                multi-line
                            ></v-text-field>
                        </el-form-item>
                    </div>
                </el-row>
                <el-row v-if="loading">
                    <div
                        class="el-form-card__element-wrapper"
                        style="margin-top: 25px"
                    >
                        <el-row v-loading="loading"></el-row>
                    </div>
                </el-row>
                <div class="button-wrapper flex justify-between items-center">
                    <v-btn
                        v-if="showSubmitBtn"
                        round
                        color="primary"
                        @click="submit"
                        :disabled="loading"
                        dark
                        >{{ formText }}
                    </v-btn>
                    <v-btn round color="dark" @click="cancel()" dark
                        >{{ formText2 }}
                    </v-btn>
                </div>
            </el-form>
        </div>
        <div></div>
    </div>
</template>

<script>
import _ from 'lodash'
import StcPassword from '../Password'
import { mapActions, mapGetters } from 'vuex'
import ScheduledGateAccess from './ScheduledGateAccess'
import InteractWithActor from '../../mixins/interact-with-actor'
import Treeselect from '@riophae/vue-treeselect'
import ContainersAndPermissions from './ContainerAndPermissions'
import StcDialog from './../Dialog'
import moment from 'moment'

export default {
    name: 'user-create',

    props: {
        gates: Array,
        schedules: Array,
    },

    data() {
        return {
            editing: false,
            loading: false,
            user: '',
            actor: {
                ActorID: '',
            },
            containersAndPermissionsModal: false,
            form: {
                culture: 'sv-SE',
                username: '',
                phone: '',
                company: '',
                password: '',
                newPassword: '',
                firstName: '',
                recipientName: '',
                recipientPhone: '',
                recipientCompany: '',
                lastName: '',
                // containerPermissions: [],
                autoPinChangeInterval: '',
                autoPinNotificationRecipient: '',
                permissions: [
                    'SUPPLIER_VIEW,UNLOADINGAREA_READ,CHECKPOINT_READ,UTIL_READ,CONTAINER_READ,USER_READ,SCHEDULETEMPLATE_READ,ACTOR_READ',
                ],
                comment: '',
                pinCode: '',
                schedule: [],
                gates: [],
                scheduledGates: {},
                allowGates: false,
                allowApp: false,
                PinValidationDisabled: false,
                OpenCommentDisabled: false,
                LocationValidationDisabled: false,
                isAdvance: false,
                isExpiryTimeEnabled: false,
                isExpiryDateEnabled: false,
                expiryTime: '00:00',
                expiryDate: '',
                ActorStatus: 0,
                destinationContainer: '',
                anpr: false,
                plateNo: '',
            },
            selectedContainers: [],
            treeValueConsistsOf: 'ALL',
            includeSubContainers: false,
            isFlat: true,
            normalizer(node) {
                let data = {
                    id: node.ContainerID,
                    label: node.Description,
                }

                if (node.Children && node.Children.length) {
                    return {
                        ...data,
                        children: node.Children,
                    }
                }

                return data
            },
            isApplyBtnVisible: false,
            treeLimit: 2,
            showContainerAndPermissions: false,
            permissionSelectDoneObj: {
                permissions: [],
                unloadingAreas: [],
            },
            userPermissions: [],
            isLoading: false,
            showSubmitBtn: true,
            timeStepper: '00:15',
            currentSelectedContainers: [],
        }
    },

    async created() {
        this.selectedContainers = [this.selectedContainer]
        this.form.expiryDate = new Date()

        // Event Handler: Show or Hide the Permissions UI (Set latest showContainerAndPermissions value.)
        // This solves a toggling issue in permissions button. (When closing the permissions UI by clicking (X) icon, need to update the showContainerAndPermissions value here)
        Events.$on('show-containers-permissions-set', (val) => {
            this.showContainerAndPermissions = val
        })
        // This captures the finalized permission list (containers <-> permissions mappings)
        Events.$on('permissions-select-done', (val) => {
            this.permissionSelectDoneObj = val

            // Show/Hide submit button on no permissions
            // if(!this.permissionSelectDoneObj.permissions || this.permissionSelectDoneObj.permissions.length === 0){
            //     this.showSubmitBtn = false
            // }else {
            //     this.showSubmitBtn = true
            // }

            // Reset the final user permission list
            this.userPermissions = []
            // This contains the full unique permission list from simple and detailed view.
            this.userPermissions.push(
                ...this.permissionSelectDoneObj.permissions
            )
            this.userPermissions.push(
                ...this.permissionSelectDoneObj.unloadingAreas
            )
        })
        // Show or hide submit button
        Events.$on('show-hide-submit-button', (val) => {
            this.showSubmitBtn = val
        })
        // Update register passings container dropdown
        Events.$on('update-register-passings', (passings) => {
            this.currentSelectedContainers = []
            if (passings && passings.length > 0) {
                this.currentSelectedContainers.push(...passings)
            }
        })
    },
    mounted() {
        this.form.company = this.me.Company
        Events.$emit('update-user-create-edit-title', true)
        Events.$on('user-editing', async (data) => {
            // console.log('USER EDIT user: ', data)
            if (this.$refs.form) {
                await this.$refs.form.resetFields()
            }
            this.resetPermissions()
            this.editing = true
            Events.$emit('update-user-create-edit-title', false)

            this.user = data
            this.fillFormUser(this.user)
            this.fillFormUserPermissions()

            if (this.user.RelatedActorID) {
                this.isLoading = true
                try {
                    this.actor = await this.fetchActorByID(
                        this.user.RelatedActorID
                    )
                    // console.log('USER EDIT actor: ', this.actor)
                    this.actor.AccessSets.forEach((accessSet) => {
                        this.fillFormAccessSet(accessSet)
                    })
                    // console.log('Form    ', this.form)
                    this.fillFormActor(this.actor)
                } catch (e) {
                    console.log(e)
                }

                this.isLoading = false

                let autoPinData = await this.fetchAutoPinData(
                    data['RelatedActorID']
                )
                this.fillFormAutoPin(autoPinData)
            }
        })
    },

    beforeDestroy() {
        Events.$off('user-editing')
        Events.$off('show-containers-permissions-set')
        Events.$off('permissions-select-done')
        Events.$off('update-register-passings')
    },

    mixins: [InteractWithActor],

    components: {
        ContainersAndPermissions,
        'stc-password': StcPassword,
        'stc-scheduled-gate-access': ScheduledGateAccess,
        treeselect: Treeselect,
        'stc-dialog': StcDialog,
    },

    watch: {
        // selectedContainerFromTreeSelect: function (container) {
        //   if(container){
        //       Events.$emit('add-container-from-user-create', container)
        //   }
        // },
        'form.allowGates': function (allowGates) {
            if (!allowGates) {
                this.form.gates = []
                this.form.pinCode = ''
                this.form.schedule = []
                this.form.comment = ''
                this.form.allowApp = false
                this.form.scheduledGates = {}
            }
            // Emitting allow gates checkbox value to Container & Permissions componenet
            Events.$emit('ut-allow-gates', allowGates)
        },

        'form.allowApp': function (allow) {
            if (allow) {
                this.form.permissions.push(
                    'CHECKPOINT_OPEN,JOB_READ,CHECKPOINT_WRITE,SCHEDULETEMPLATE_READ,UNLOADINGAREA_READ,APP_INTERNAL_STCMOBILE'
                )
            } else {
                const index = this.form.permissions.indexOf(
                    'CHECKPOINT_OPEN,JOB_READ,CHECKPOINT_WRITE,SCHEDULETEMPLATE_READ,UNLOADINGAREA_READ,APP_INTERNAL_STCMOBILE'
                )

                this.form.permissions.splice(index, 1)

                this.form.PinValidationDisabled = false
                this.form.OpenCommentDisabled = false
                this.form.LocationValidationDisabled = false
            }
            Events.$emit('ut-allow-app', allow)
        },

        'form.schedule': function (newVal, oldVal) {
            const diff = _.difference(oldVal, newVal)

            diff.forEach((item) =>
                Vue.delete(this.form.scheduledGates, item.ScheduleTemplateID)
            )
        },

        selectedContainer() {
            if (this.editing) {
                this.reset()
            }
        },
    },

    computed: {
        ...mapGetters([
            'permissions',
            'selectedContainer',
            'containerTree',
            'containers',
        ]),

        formText() {
            return this.editing
                ? this.$t('form.title.update')
                : this.$t('form.title.create')
        },
        formText2() {
            return this.editing
                ? this.$t('form.button.cancel')
                : this.$t('button.text.reset')
        },

        me() {
            return this.$auth.user()
        },

        actionList() {
            let actionList = []

            this.form.permissions.forEach((action) => {
                let actions = action.split(',')

                actions.forEach((action) => {
                    actionList.push(action)
                })
            })

            return _.uniq(actionList)
        },

        actorPayload() {
            this.form.recipientPhone = this.form.phone
            this.form.recipientCompany = this.form.company
            this.form.recipientName = `${this.form.firstName} ${this.form.lastName}`

            return {
                ActorType: 'STANDARD',
                Email: this.form.username,
                FirstName: this.form.firstName,
                LastName: this.form.lastName,
                MAIsEnabled: this.form.allowApp,
                Comment: this.form.comment,
                Company: this.form.company,
                Phone: this.form.phone,
                PinCode: this.form.pinCode,
                PlateNo: this.form.plateNo,
                Status: this.form.ActorStatus,
                AccessSets: this.buildAccessSet(this.form),
                PinValidationDisabled: !this.form.PinValidationDisabled,
                OpenCommentDisabled: !this.form.OpenCommentDisabled,
                LocationValidationDisabled:
                    !this.form.LocationValidationDisabled,
            }
        },

        rules() {
            const rules = {
                username: [
                    {
                        required: true,
                        message: this.$t('form.validation.required', {
                            name: this.$t('form.label.email'),
                        }),
                        trigger: 'blur',
                    },
                    {
                        type: 'email',
                        message: this.$t('form.validation.valid', {
                            name: this.$t('form.label.email'),
                        }),
                        trigger: 'blur,change',
                    },
                ],
                firstName: [
                    {
                        required: true,
                        message: this.$t('form.validation.required', {
                            name: this.$t('form.label.firstName'),
                        }),
                        trigger: 'blur',
                    },
                ],
                phone: [
                    {
                        required: true,
                        message: this.$t('form.validation.required', {
                            name: this.$t('form.label.phone'),
                        }),
                        trigger: 'blur',
                    },
                ],
                company: [
                    {
                        required: true,
                        message: this.$t('form.validation.required', {
                            name: this.$t('form.label.company'),
                        }),
                        trigger: 'blur',
                    },
                ],
                lastName: [
                    {
                        required: true,
                        message: this.$t('form.validation.required', {
                            name: this.$t('form.label.lastName'),
                        }),
                        trigger: 'blur',
                    },
                ],
                password: [
                    {
                        required: !this.editing,
                        message: this.$t('form.validation.required', {
                            name: this.$t('form.label.password'),
                        }),
                        trigger: 'blur',
                    },
                    {
                        pattern:
                            /((?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[\W]).{8,64})/g,
                        message: this.$t(
                            'form.validation.passwordValidateMessage'
                        ),
                        trigger: 'blur,change',
                    },
                ],
                pinCode: [
                    {
                        required: true,
                        message: this.$t('form.validation.required', {
                            name: this.$t('form.label.pinCode'),
                        }),
                        trigger: 'blur',
                    },
                    {
                        pattern: /^[0-9]{6}$/,
                        message: this.$t('form.validation.minNumberDigits', {
                            name: this.$t('form.label.pinCode'),
                            number: 6,
                        }),
                        trigger: 'blur,change',
                    },
                ],
                schedule: [
                    {
                        required: true,
                        message: this.$t('form.validation.required', {
                            name: this.$t('form.label.selectSchedule'),
                        }),
                        trigger: 'blur',
                    },
                ],
                destinationContainer: [
                    {
                        required: true,
                        message: this.$t('form.validation.required', {
                            name: this.$t('form.label.registerPassings'),
                        }),
                        trigger: 'blur',
                    },
                ],
            }

            Vue.nextTick(() => this.$refs.form.clearValidate())

            return rules
        },

        pickerOptions() {
            return {
                firstDayOfWeek: 1,
            }
        },
    },

    methods: {
        buildAccessSet(data, actorType = null) {
            let accessSet = []

            if (data.hasOwnProperty('allowGates') && data.allowGates) {
                const gates = _.chain(data.scheduledGates)
                    .flatMap((val) => val)
                    .uniq()
                    .value()

                gates.forEach((gate) => {
                    accessSet.push(this.buildGateAccessForDirection(gate, data))
                })
            } else {
                data.gates.forEach((gate) => {
                    if (gate.DirectionInEnabled) {
                        accessSet.push(
                            this.buildGateAccessForDirection(
                                gate,
                                data,
                                'in',
                                actorType
                            )
                        )
                    }

                    if (gate.DirectionOutEnabled) {
                        accessSet.push(
                            this.buildGateAccessForDirection(
                                gate,
                                data,
                                'out',
                                actorType
                            )
                        )
                    }
                })
            }

            return accessSet
        },

        buildGateAccessForDirection(
            gate,
            data,
            direction = null,
            actorType = null
        ) {
            let access = {}

            access['Schedules'] = []
            access['CheckPointID'] = gate['CheckpointID']

            access['DestinationContainerID'] =
                this.form.destinationContainer.ContainerID

            if (data.hasOwnProperty('unloadingArea') && data.unloadingArea) {
                access['UnloadingAreaID'] =
                    data.unloadingArea.UnloadingAreaID || data.unloadingArea
            }

            if (data.hasOwnProperty('recipientName')) {
                access['RecipientName'] = data.recipientName
            }

            if (data.hasOwnProperty('recipientCompany')) {
                access['RecipientCompany'] = data.recipientCompany
            }

            if (data.hasOwnProperty('recipientPhone')) {
                access['RecipientPhone'] = data.recipientPhone
            }

            if (data.hasOwnProperty('requestedResources')) {
                access['RequestedResources'] = data.requestedResources
            }

            if (direction) {
                let part = _.cloneDeep(_.first(data.schedule['ScheduleParts']))
                delete part['SchedulePartTemplateID']
                part['Direction'] = direction.toUpperCase()

                if (
                    data.hasOwnProperty('dateTimeRange') &&
                    data.dateTimeRange.length
                ) {
                    part['ValidFrom'] = DateTime.fromISO(
                        data.dateTimeRange[0].toISOString()
                    ).toFormat(this.dateTimeFormat)
                    part['ValidTo'] = DateTime.fromISO(
                        data.dateTimeRange[1].toISOString()
                    ).toFormat(this.dateTimeFormat)
                }

                if (data.hasOwnProperty('preFlex')) {
                    part['PreFlex'] = data.preFlex
                }

                access['Schedules'] = [
                    {
                        ScheduleParts: [part],
                        Description: data.schedule.Description,
                    },
                ]
            }

            if (data.hasOwnProperty('scheduledGates')) {
                access['ScheduleTemplates'] = []

                Object.keys(data.scheduledGates).forEach((schedule) => {
                    if (
                        _.findIndex(data.scheduledGates[schedule], {
                            CheckpointID: gate['CheckpointID'],
                        }) > -1
                    ) {
                        access['ScheduleTemplates'].push(schedule)
                    }
                })
            }

            return access
        },
        async cancel() {
            try {
                if (this.editing) {
                    await this.$confirm(
                        this.$i18n.i18next.t('message.warning.resetUser', {
                            section: this.$i18n.i18next.t('text.user'),
                        }),
                        'Warning',
                        {
                            confirmButtonText: this.$i18n.i18next.t(
                                'button.text.confirm'
                            ),
                            cancelButtonText:
                                this.$i18n.i18next.t('button.text.cancel'),
                            type: 'warning',
                        }
                    )
                    this.closeContainersAndPermissions()
                } else {
                    await this.$confirm(
                        this.$i18n.i18next.t('message.warning.reset', {
                            section: this.$i18n.i18next.t('text.user'),
                        }),
                        'Warning',
                        {
                            confirmButtonText: this.$i18n.i18next.t(
                                'button.text.confirm'
                            ),
                            cancelButtonText:
                                this.$i18n.i18next.t('button.text.cancel'),
                            type: 'warning',
                        }
                    )
                    this.reset()
                }

                return true
            } catch (e) {
                return false
            }
        },
        closeContainersAndPermissions() {
            Events.$emit('show-create-or-edit-view', false)
        },
        async handleBeforeClearAll() {
            try {
                await this.$confirm(
                    'Are you sure you want clear the fields?',
                    'Warning',
                    {
                        confirmButtonText: this.$i18n.i18next.t(
                            'button.text.confirm'
                        ),
                        cancelButtonText:
                            this.$i18n.i18next.t('button.text.cancel'),
                        type: 'warning',
                    }
                )
                return true
            } catch (e) {
                return false
            }
        },
        changeIncludeSubContainers() {
            if (this.includeSubContainers) {
                this.selectedContainers = null
                setTimeout(
                    function () {
                        this.isFlat = false
                        this.isFlat = false
                    }.bind(this),
                    1000
                )
            } else {
                this.selectedContainers = null
                setTimeout(
                    function () {
                        this.isFlat = true
                    }.bind(this),
                    1000
                )
            }
        },
        handleScheduledGates({ schedule, gates }) {
            if (!gates.length) {
                Vue.delete(
                    this.form.scheduledGates,
                    schedule.ScheduleTemplateID
                )
                if (this.form.schedule && this.form.schedule.length > 0) {
                    this.form.schedule = this.form.schedule.filter((obj) => {
                        return obj.Description !== schedule.Description
                    })
                }
            } else {
                Vue.set(
                    this.form.scheduledGates,
                    schedule.ScheduleTemplateID,
                    gates
                )
            }
        },

        resetPermissions() {
            let permissions = []

            permissions.push(
                'SUPPLIER_VIEW,UNLOADINGAREA_READ,CHECKPOINT_READ,UTIL_READ,CONTAINER_READ,USER_READ,SCHEDULETEMPLATE_READ,ACTOR_READ'
            )

            this.form.permissions = permissions
        },

        reset() {
            if (this.$refs.form) {
                this.$refs.form.resetFields()
            }
            this.resetPermissions()

            this.form.company = this.me.Company

            this.actor = {
                ActorID: '',
            }
            this.user = ''
            this.editing = false
        },

        fillFormUser(user) {
            this.form.username = user.UserName
            this.form.firstName = user.FirstName
            this.form.lastName = user.LastName
            this.form.company = user.Company
            this.form.phone = user.Phone
            this.form.ActorStatus = user.Status
            this.form.culture = user.Culture || this.form.culture
            this.form.containerPermissions = _.uniq(
                _.map(user.Permissions, 'ContainerID')
            )
            if (user.ExpiryDateTime) {
                const date = new moment(
                    user.ExpiryDateTime,
                    'YYYY-MM-DDTHH:mm:ss.SSS'
                )
                this.form.isExpiryDateEnabled = true

                this.form.expiryDate = date.toDate()
                this.form.isExpiryTimeEnabled = true

                const time = moment(user.ExpiryDateTime).format('HH:mm')
                if (time) {
                    this.form.isExpiryTimeEnabled = true
                    this.form.expiryTime = time
                }
            }
        },

        async fillFormUserPermissions() {
            const containerIds = _.uniq(
                _.map(this.user.Permissions, 'ContainerID')
            )
            let finalFiltered = []
            containerIds.forEach((id) => {
                const filtered = _.filter(this.containers, { ContainerID: id })
                if (filtered && filtered.length > 0) {
                    finalFiltered.push(filtered[0])
                }
            })
            this.currentSelectedContainers = finalFiltered

            const permissions = _.map(this.user.Permissions, 'Permission')

            if (_.includes(permissions, 'ACTOR_WRITE')) {
                this.form.permissions.push('ACTOR_WRITE,ACTOR_DELETE')
            }

            if (_.includes(permissions, 'USER_WRITE')) {
                this.form.permissions.push('USER_WRITE,USER_DELETE')
            }

            if (_.includes(permissions, 'BLC_READ')) {
                this.form.permissions.push(
                    'BLC_READ,BLC_WRITE,VEHICLE_READ,ACTOR_WRITE'
                )
            }

            if (_.includes(permissions, 'CONTAINER_WRITE')) {
                this.form.permissions.push('CONTAINER_WRITE')
            }

            if (_.includes(permissions, 'SCHEDULETEMPLATE_WRITE')) {
                this.form.permissions.push(
                    'SCHEDULETEMPLATE_WRITE,SCHEDULETEMPLATE_DELETE,SCHEDULETEMPLATE_READ'
                )
            }

            if (_.includes(permissions, 'SUPPLIER_MANAGE')) {
                this.form.permissions.push('SUPPLIER_MANAGE')
            }

            if (_.includes(permissions, 'SUPER_USER')) {
                this.form.permissions.push('SUPER_USER')
            }

            const serverPermissions = _.difference(permissions, this.actionList)

            if (serverPermissions.length) {
                this.form.permissions = [
                    ...this.form.permissions,
                    ...serverPermissions,
                ]
            }
        },

        fillFormActor(actor) {
            this.form.allowApp = actor.MAIsEnabled
            this.form.pinCode = actor.PinCode || ''
            this.form.comment = actor.Comment || ''
            this.form.PinValidationDisabled = !actor.PinValidationDisabled
            this.form.OpenCommentDisabled = !actor.OpenCommentDisabled
            this.form.LocationValidationDisabled =
                !actor.LocationValidationDisabled

            this.form.allowGates = true
            if (actor.PlateNo) {
                this.form.anpr = true
                this.form.plateNo = actor.PlateNo
            }
            if (actor.AccessSets && actor.AccessSets.length > 0) {
                const containerId = actor.AccessSets[0].DestinationContainerID
                if (containerId) {
                    const filtered = _.filter(this.containers, {
                        ContainerID: containerId,
                    })
                    if (filtered && filtered.length > 0) {
                        this.form.destinationContainer = filtered[0]
                    }
                }
            }
        },

        fillFormAutoPin(data) {
            this.form.autoPinChangeInterval = data.ChangeInterval
            this.form.autoPinNotificationRecipient = data.NotificationRecipient
            this.form.isAdvance =
                data.ChangeInterval || data.NotificationRecipient
        },

        fillFormAccessSet(accessSet) {
            const gate = _.find(this.gates, {
                CheckpointID: accessSet['CheckPointID'],
            })
            if (gate) {
                accessSet.ScheduleTemplates.forEach((schedule) => {
                    if (schedule.ScheduleTemplateID) {
                        // STC-461: Adding Schedules in Actor response to current schedules
                        this.schedules.push(schedule)
                        schedule = _.find(this.schedules, {
                            ScheduleTemplateID: schedule.ScheduleTemplateID,
                        })

                        if (schedule) {
                            if (
                                !this.form.scheduledGates[
                                    schedule.ScheduleTemplateID
                                ]
                            ) {
                                Vue.set(
                                    this.form.scheduledGates,
                                    schedule.ScheduleTemplateID,
                                    []
                                )
                            }

                            if (!this.form.schedule.includes(schedule)) {
                                this.form.schedule.push(schedule)
                            }

                            if (
                                !this.form.scheduledGates[
                                    schedule.ScheduleTemplateID
                                ].includes(gate)
                            ) {
                                this.form.scheduledGates[
                                    schedule.ScheduleTemplateID
                                ].push(gate)
                            }
                        }
                    }
                })
            }
        },

        async submit() {
            // Validate the user form
            await this.$refs.form.validate()

            if (
                this.editing &&
                !this.permissions.includes('SUPER_USER') &&
                (this.user.Status === 98 || this.user.Status === 99)
            ) {
                this.$message({
                    type: 'warning',
                    showClose: true,
                    message: this.$i18n.i18next.t(
                        'message.warning.insufficientPermissions'
                    ),
                })
                return false
            }

            let permissions = []

            if (!this.userPermissions || this.userPermissions.length === 0) {
                try {
                    await this.$confirm(
                        this.$i18n.i18next.t(
                            'message.warning.noPermissionsSelected',
                            {
                                section: 'notification',
                            }
                        ),
                        'Warning',
                        {
                            confirmButtonText: this.$i18n.i18next.t(
                                'button.text.confirm'
                            ),
                            cancelButtonText:
                                this.$i18n.i18next.t('button.text.cancel'),
                            type: 'warning',
                        }
                    )
                } catch (e) {
                    if (e === 'cancel') {
                        return false
                    } else {
                        this.$message({
                            type: 'error',
                            showClose: true,
                            message: this.$i18n.i18next.t(
                                'message.error.general'
                            ),
                        })
                        return false
                    }
                }
            }

            permissions.push(...this.userPermissions)

            permissions = _.uniqWith(
                permissions,
                (permissionA, permissionB) =>
                    permissionA.ContainerID === permissionB.ContainerID &&
                    permissionA.Permission === permissionB.Permission
            )

            let expiryDateTime = null
            if (
                this.form.isExpiryDateEnabled ||
                this.form.isExpiryTimeEnabled
            ) {
                const currentDateTime = new Date()
                let date = this.form.expiryDate
                if (!this.form.isExpiryDateEnabled) date = currentDateTime
                const month = date.getMonth() + 1
                const day = date.getDate()
                if (!this.form.isExpiryTimeEnabled) {
                    expiryDateTime =
                        date.getFullYear() +
                        '-' +
                        (month <= 9 ? '0' + month : month) +
                        '-' +
                        (day <= 9 ? '0' + day : day) +
                        'T23:59:59.000'
                } else {
                    const time = this.form.expiryTime
                    if (time && time.includes(':')) {
                        expiryDateTime =
                            date.getFullYear() +
                            '-' +
                            (month <= 9 ? '0' + month : month) +
                            '-' +
                            (day <= 9 ? '0' + day : day) +
                            'T' +
                            time +
                            ':00.000'
                    }
                }

                if (!moment(expiryDateTime).isSameOrAfter(currentDateTime)) {
                    this.$message({
                        type: 'warning',
                        showClose: true,
                        message: this.$i18n.i18next.t(
                            'message.warning.invalidSelection',
                            {
                                selection: this.$i18n.i18next.t(
                                    'form.label.expiryDateTime'
                                ),
                            }
                        ),
                    })
                    return false
                }
            }

            let userPayload = {
                UserName: this.form.username,
                Password: this.form.password,
                FirstName: this.form.firstName,
                LastName: this.form.lastName,
                Company: this.form.company,
                Phone: this.form.phone,
                Culture: this.form.culture,
                RelatedActorID: this.actor.ActorID,
                Permissions: permissions,
                ExpiryDateTime: expiryDateTime,
                ContainerID: this.selectedContainer.ContainerID,
            }

            // console.log(permissions.map((it) => it.Permission))

            this.loading = true

            try {
                // Validate check point gates
                const selectedSchedules1 = this.form.schedule.map(
                    (schedule) => schedule.ScheduleTemplateID
                )
                let selectedSchedules2 = []
                if (this.form.scheduledGates) {
                    selectedSchedules2 = Object.keys(this.form.scheduledGates)
                }
                if (
                    selectedSchedules1.filter(
                        (e) => !selectedSchedules2.includes(e)
                    ).length > 0
                ) {
                    this.$message({
                        type: 'error',
                        showClose: true,
                        message: `Please fill out all required fields.`,
                    })
                    this.loading = false
                    return
                }

                // Check allow gates and update actor
                if (this.form.allowGates) {
                    if (this.actor.ActorID) {
                        this.$http.put(
                            `Actor/${this.actor.ActorID}`,
                            this.actorPayload
                        )
                    } else {
                        let { data } = await this.$http.post(
                            'Actor',
                            this.actorPayload
                        )
                        this.actor.ActorID = data
                    }
                    userPayload.RelatedActorID = this.actor.ActorID
                } else {
                    if (this.actor.ActorID) {
                        this.$http.delete(`Actor/${this.actor.ActorID}`)
                        this.actor = {
                            ActorID: '',
                        }
                        userPayload.RelatedActorID = ''
                    }
                }

                if (this.form.isAdvance && this.actor.ActorID) {
                    this.$http.post(`Actor/${this.actor.ActorID}/AutoPin`, {
                        NotificationRecipient:
                            this.form.autoPinNotificationRecipient,
                        ChangeInterval: this.form.autoPinChangeInterval,
                    })
                } else {
                    if (this.actor.ActorID) {
                        this.$http.post(`Actor/${this.actor.ActorID}/AutoPin`, {
                            NotificationRecipient: '',
                            ChangeInterval: 0,
                        })
                    }
                }

                let method = this.editing ? 'put' : 'post'
                let url = this.editing ? `User/${this.user.UserID}` : 'User'

                // console.log('SAVE USER', method + ' ' + url)
                // console.log('SAVE USER userPayload: ', userPayload)

                let userResponse = await this.$http[method](url, userPayload)

                if (this.editing && this.form.newPassword) {
                    const passwordValidationRegex =
                        /((?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[\W]).{8,64})/g
                    if (this.form.newPassword.match(passwordValidationRegex)) {
                        this.$http.post(
                            `User/${this.user.UserID}/SetPassword`,
                            {
                                password: this.form.newPassword,
                            }
                        )
                    } else {
                        this.loading = false
                        this.$message({
                            type: 'error',
                            showClose: true,
                            message: this.$i18n.i18next.t(
                                'form.validation.passwordValidateMessage'
                            ),
                        })
                        return
                    }
                }

                if (this.user && this.user.UserID === this.me.UserID) {
                    this.fetchContainerPermissions()
                    let { data } = await this.$auth.fetch()

                    this.$auth.user(data)
                }

                this.$message({
                    type: 'success',
                    showClose: true,
                    message: this.editing
                        ? this.$i18n.i18next.t('message.success.updated', {
                              section: this.$i18n.i18next.t('text.user'),
                          })
                        : this.$i18n.i18next.t('message.success.created', {
                              section: this.$i18n.i18next.t('text.user'),
                          }),
                })

                this.userPermissions.length = 0

                // Close user create/edit view
                Events.$emit('show-create-or-edit-view', false)

                // Update Scenario
                if (this.editing) {
                    // Update current user list
                    // console.log(this.user)
                    if (userResponse && userResponse.status === 200) {
                        userPayload.UserID = this.user.UserID
                        userPayload.ContainerId = this.user.ContainerId
                        userPayload.ContainerDescription =
                            this.user.ContainerDescription
                        userPayload.Status = this.user.Status
                        Events.$emit('user-updated', [this.selectedContainer])
                    }
                } else {
                    // Create Scenario
                    // Get user list of the container which belongs to the created user
                    Events.$emit('user-updated', [this.selectedContainer])
                }

                // Reset form
                // this.reset()
            } catch (e) {
                console.error(e)
                if (e === false) {
                    this.$message({
                        type: 'error',
                        showClose: true,
                        message: `Please fill out all required fields.`,
                    })
                } else {
                    this.$message({
                        type: 'error',
                        showClose: true,
                        message: `${e.response.data}.`,
                    })
                }
            }

            this.loading = false
        },

        async fetchAutoPinData(actorId) {
            let { data } = await this.$http.get(`Actor/${actorId}/AutoPin`)

            return data
        },

        ...mapActions(['fetchContainerPermissions']),
    },
}
</script>

<style lang="scss" scoped>
.cell {
    .el-form-item--mini {
        margin-bottom: 0 !important;
    }
}
</style>
<style>
.el-dialog__title {
    color: white;
}

.btnCls:visited {
    background-color: #dd4814 !important;
}

.btnCls:active {
    background-color: #dd4814 !important;
}

.btnCls:focus {
    background-color: #dd4814 !important;
}

.btnCls:hover {
    background-color: #dd4814 !important;
}

.el-dialog {
    margin-top: 5vh !important;
}

.date-wrapper {
    margin-top: 10px;
}
.el-input.is-disabled .el-input__inner {
    background-color: #3b424e;
    border-color: #515a67;
}
</style>
